<mat-icon
	[class.biggerFAIcon]="biggerFAIcon()"
	[fontIcon]="trigger() ? endIcon().fontIcon : startIcon().fontIcon"
	[fontSet]="trigger() ? endIcon().fontSet : startIcon().fontSet"
	[ngClass]="classes()"
	color="{{ trigger() ? endIcon().themeColor : startIcon().themeColor }}"
	class="fontAwesomeAnimatedIcon"
	inline
/>
